var popupElement = function(elementID,config={}){
  this.elementID = elementID;
  this.config = config;
  this.popup = document.getElementById(elementID);
  this.load();
};

popupElement.prototype.load = function(){

  this.popup.classList.add("popupElement");
  var popupHolder = document.createElement("div");
  popupHolder.classList.add("popupElementHolder");

  if(this.config.noHeight){
    popupHolder.style.height = "auto";
  }

  var popupScroll = document.createElement("div");
  popupScroll.classList.add("popupElementScroll");
  popupScroll.innerHTML = this.popup.innerHTML;
  popupHolder.append(popupScroll);

  this.popup.innerHTML = "";
  this.popup.append(popupHolder);

  var popupClose = document.createElement("div");
  popupClose.innerHTML = "&times;";
  popupClose.classList.add("popupElementClose");
  popupHolder.append(popupClose);

  if(this.config.onload){
      this.config.onload();
  }

  this.events();



};

popupElement.prototype.setHTML = function(html){
  var el = this.popup.getElementsByClassName("popupElementScroll");
  if(el && el[0]){
    el[0].innerHTML = html;
  }
};

popupElement.prototype.events = function(){

  var openLinks = document.querySelectorAll("*[data-popup='"+this.elementID+"']");

  for(let l of openLinks){
    l.addEventListener("click",(e)=>{
      e.preventDefault();
      this.open();
    });
  }

  var closeLinks = this.popup.querySelectorAll(".popupElementClose");
  if(closeLinks){
    closeLinks.forEach(c=>{
      c.addEventListener("click",(e)=>{
        e.preventDefault();
        this.close();
      });
    });
  }



  this.popup.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget){
      return;
    }
    this.close();
  });

};

popupElement.prototype.open = function(){
  this.popup.classList.add("show");
};

popupElement.prototype.close = function(){
  this.popup.classList.remove("show");
  if(this.config.onclose){
    this.config.onclose();
  }
};
